<template>
  <div>
    <div class="mask_contents-wrap st_type02">
      <p class="txt_complete"><i class="blt_complete"></i>예약이 완료되었습니다.</p>
      <div class="order_infos">
        <p class="order_info_msg">주문은 <span class="date">{{openDate + openDayOfWeek + opentime}}</span>부터 가능합니다.</p>
        <p class="order_info_btn">
          <button type="button" name="order" class="btn_type-t disable" @click ="gotoOrder" :disabled="orderable">주문</button>
          <!-- <button type="button" name="order" class="btn_type-t disable" @click ="gotoOrder">주문</button> -->
        </p>
      </div>
      <div class="reservation-info">
        <h2 class="title_type-b">예약 정보</h2>
        <dl class="reservation_data">
          <dt class="reservation_title">예약 번호</dt>
          <dd class="reservation_value">{{ reservationseq }}</dd>
        </dl>
        <dl class="reservation_data">
          <dt class="reservation_title">예약일</dt>
          <dd class="reservation_value">{{ c_date }}</dd>
        </dl>
        <dl class="reservation_data">
          <dt class="reservation_title">ABO 번호</dt>
          <dd class="reservation_value">{{ c_abo_no }}</dd>
        </dl>
      </div>
      <div class="reservation_product" id="large" v-show="r_sku1">
        <div class="product_img"><img src="./images/mask_big.jpg" alt=""></div>
        <div class="product_data">
          <p class="product_name">대형 (295882K)</p>
          <p class="product_price"><span class="product_value">32,000</span>원 / <span class="product_value">1</span>개</p>
        </div>
      </div>
      <div class="reservation_product" id="small" v-show="r_sku2">
        <div class="product_img"><img src="./images/mask_small.jpg" alt=""></div>
        <div class="product_data">
          <p class="product_name">소형 (295883K)</p>
          <p class="product_price"><span class="product_value">32,000</span>원 / <span class="product_value">1</span>개</p>
        </div>
      </div>
      <div class="banner-area">
        <img src="./images/banner.png" alt="엣모피어스 스카이 좋은 공기만으로 생활은 달라질 수 있습니다.">
      </div>
    </div>
  </div>
</template>

<script>
import $ from 'jquery'
import Vue from 'vue'
import axios from 'axios'
import VueTheMask from 'vue-the-mask'
import querystring from 'querystring'

Vue.use(VueTheMask)

export default {
  name: 'atmosphere-mask-reservations-complete',
  data () {
    return {
      openDate: '',
      opentime: '',
      openDayOfWeek: '',
      isOpen: false,
      r_sku1: false, // sku1예약 여부
      r_sku2: false, // sku2예약 여부
      reservationseq: '', // url시퀀스
      abo_no: '', // url시퀀스에서 획득한 abo번호
      serial_no: '', // url시퀀스에서 획득한 일련번호
      c_abo_no: '', // 예약한abo번호
      c_seq: '', // 예약번호
      c_date: '', // 예약날짜
      c_day: '',
      c_orderable_time: '', // 주문가능시간
      c_sku1: '', // 예약sku1
      c_qty1: '', // 주문수량1
      c_qty2: '', // 주문수량2
      c_share_list: '', // 주문여부 확인
      orderable: false, // 주문가능 확인
      return_code: '',
      token_body: {
        client_id: process.env.OCC_AUTH_CLIENT_ID,
        client_secret: process.env.OCC_AUTH_CLIENT_SECRET,
        grant_type: process.env.OCC_AUTH_GRANT_TYPE
      },
      token_data: [],
      au_token: '',
      redirect_url: '',
      year: '',
      month: '',
      day: '',
      url: ''
    }
  },
  methods: {
    reservTimeCheck () {
      if (this.stockCheck()) { // 재고 확인
        if (!this.orderTimeCheck()) { // 주문 가능시간 확인
          this.orderable = true
          this.scheduleUpdateCheck()
        } else {
          // 주문 가능
          $('.btn_type-t').removeClass('disable')
        }
      }
    },
    scheduleUpdateCheck () { // 1초마다 주문 가능시간 체크
      setTimeout(this.reservTimeCheck, 1000)
    },
    getReservationData () {
      // abo 및 일련번호 추출
      this.abo_no = this.reservationseq.substring(0, (this.reservationseq.length - 2))
      this.serial_no = this.reservationseq.slice(-2)

      // 예약정보 및 재고 확인
      axios.post(
        process.env.AWS_GATEWAY_URL + '/mask-promotion/confirm',
        {
          search_abo: this.abo_no,
          search_seq: this.serial_no
        },
        {
          headers: {
            'Content-Type': 'application/json;charset=UTF-8'
          }
        }).then(response => {
        if (response.status === 200) {
          if (response.data.searchAbo === null) {
            alert('죄송합니다. 예약정보가 없습니다.\n다시 시도해 주세요.')
          } else {
            // 예약정보
            this.c_abo_no = response.data.searchAbo.ABO_NO
            this.c_seq = response.data.searchAbo.SEQ
            this.c_date = response.data.searchAbo.INSERT_DATE
            this.c_orderable_time = response.data.searchAbo.ORDERABLE_TIME // yyyy-mm-dd hh:mm:ss
            // this.orderable = response.data.searchAbo.SHARE_LIST != null // 주문 가능 여부
            this.openDate = this.c_orderable_time.substring(0, 10) // yyyy-mm-dd
            this.opentime = this.c_orderable_time.substring(11, 16) // yyyy-mm-dd
            this.c_day = [' (일) ', ' (월) ', ' (화) ', ' (수) ', ' (목) ', ' (금) ', ' (토) ']
            this.openDayOfWeek = this.c_day[new Date(this.openDate).getDay()]
            this.c_sku1 = response.data.searchAbo.SKU1
            this.return_code = response.data.searchAbo.returnCode

            // 예약한 제품의 SKU를 확인
            if (this.c_sku1 === '295882K') this.r_sku1 = true
            else if (this.c_sku1 === '295883K') this.r_sku2 = true

            // 재고수량 확인
            this.c_qty1 = response.data.searchQty.Qty1
            this.c_qty2 = response.data.searchQty.Qty2

            // 예약시간 확인 후 버튼
            this.reservTimeCheck()
          }
        } else {
          console.log('response.status : ', response.status)
          alert('죄송합니다. 에러가 발생했습니다.\n다시 시도해 주세요.')
        }
      }).catch(error => {
        console.log('error : ', error)
        alert('죄송합니다. 에러가 발생했습니다.\n다시 시도해 주세요.')
      })
    },
    orderTimeCheck () { // 주문시간 확인
      this.year = this.openDate.substring(0, 4)
      this.month = this.openDate.substring(5, 7)
      this.day = this.openDate.substring(8, 10)
      this.isOpen = new Date(this.month + '/' + this.day + '/' + this.year + ' ' + this.opentime) < new Date()
      return this.isOpen
    },
    stockCheck () { // 재고 확인
      if (this.r_sku1) {
        if (this.c_qty1 <= 0) {
          $('#large').addClass('soldout')
          this.orderable = true
          return false
        }
      } else if (this.r_sku2) {
        if (this.c_qty2 <= 0) {
          $('#small').addClass('soldout')
          this.orderable = true
          return false
        }
      }
      return true
    },
    gotoOrder () {
      // 주문여부 재확인 > 재고 확인 > 인증 토큰 발급 > 쉐어 리스트 이동 > 마스크 오더 확인
      axios.post( // 인증 토큰 발급
        process.env.OCC_AUTH_TOKEN_URL, querystring.stringify(this.token_body),
        {
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
          }
        }).then(response => {
        if (response.status === 200) {
          if (response.data.searchAbo === null) {
            alert('죄송합니다. 예약접속자가 많아서 현재 접수가 지연되고 있습니다.\n다시 시도해 주세요.')
          } else {
            // shareList 생성
            this.au_token = response.data.access_token
            this.getShareList()
          }
        } else {
          console.log('response.status : ', response.status)
          alert('죄송합니다. 인증에 실패했습니다.\n다시 시도해 주세요.')
        }
      }).catch(error => {
        console.log('error : ', error)
        alert('죄송합니다. 인증에 실패했습니다.\n다시 시도해 주세요.')
      })
    },
    getShareList () {
      axios.post(
        process.env.SHARE_LIST_URL + this.abo_no + '/create/CART',
        {
          title: '공유제품 목록',
          description: '',
          cartEntries: [
            {productCode: this.c_sku1, quantity: '1'}
          ],
          couponEntries: []
        },
        {
          headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + this.au_token
          }
        }).then(response => {
        if (response.status === 200) {
          this.redirect_url = response.data.url
          this.setMaskOrder()
        } else {
          alert('죄송합니다. 인증되지 않은 유저입니다.\n다시 시도해 주세요.')
        }
      }).catch(error => {
        console.log('error : ', error)
        alert('죄송합니다. 인증되지 않은 유저입니다.\n다시 시도해 주세요.')
      })
    },
    setMaskOrder () {
      axios.post(
        process.env.AWS_GATEWAY_URL + '/mask-promotion/order',
        {
          search_abo: this.c_abo_no,
          search_seq: this.c_seq,
          share_list: this.redirect_url
        },
        {
          headers: {
            'Content-Type': 'text/plain'
          }
        }).then(response => {
        if (response.status === 200) {
          // 화면이동
          this.redirectCart()
        } else {
          console.log('response.status : ', response.status)
          alert('죄송합니다. 예약접속자가 많아서 현재 접수가 지연되고 있습니다.\n다시 시도해 주세요.')
        }
      }).catch(error => {
        console.log('error : ', error)
        alert('죄송합니다. 예약접속자가 많아서 현재 접수가 지연되고 있습니다.\n다시 시도해 주세요.')
      })
    },
    redirectCart () {
      window.open(this.redirect_url, '_self')
    }
  },
  created: function () {
    // 파라메터에서 예약번호 추출
    this.reservationseq = this.$route.params.reservation
  },
  mounted: function () {
    // 예약정보 추출 및 세팅
    this.getReservationData()
  }
}
</script>

<style>
@import url('https://fonts.googleapis.com/css?family=Noto+Sans+KR:300,400,500,700&subset=korean');
@import './css/mask2.css';
</style>



// WEBPACK FOOTER //
// src/views/atmosphere-mask/shareComplete.vue